<template>
  <div class="background-modal align-modal" id="outModal" onkeypress="onClick">
    <div class="content">
      <div class="header"> 
        <div id="header-row">
          <p id="header-title">Detalhes do contato</p>
          <i class="fas fa-times" id="close-button" @click="dismissModal"></i>
        </div>
      </div>
      <div class="body">
        <div id="img-container">
          <img src="/imgs/default-profile.png">
        </div>
        <div id="details-container">
          <div class="custom-input-group">
            <label for="name">Nome</label>
            <input type="text" class="form-control" name="name" id="name" v-model="updateData.name" required :disabled="disable">
          </div>
          <div class="custom-input-group">
            <label for="phone">Telefone</label>
            <vue-tel-input 
              id="vlTel1" 
              v-model="updateData.phone"
              :input-options="options"
              mode="international" 
              :disabled="disable"
              :default-country="getDefaultCountryCode"
              :country="updateData.countryCode"
            ></vue-tel-input>
          </div>
          <div class="custom-input-group">
            <label for="empresa">Empresa</label>
            <!-- <input type="text" class="form-control" name="empresa" id="empresa" v-model="updateData.company_name" :disabled="disable"> -->
            <v-select :options="optionsEmpresas" v-model="updateData.company_name" id="empresa" name="empresa" :disabled="disable"></v-select>
          </div>
          <div class="custom-input-group">
            <label for="sub-empresa">Sub-empresa</label>
            <!-- <input type="text" class="form-control" name="sub-empresa" id="sub-empresa" v-model="updateData.corporation" :disabled="disable"> -->
            <v-select :options="optionsSubEmpresasFilter()" v-model="updateData.corporation" name="sub-empresa" id="sub-empresa" :disabled="disable"></v-select>
          </div>
          <div class="custom-input-group">
            <label for="chave-unica">Funcional</label>
            <input
              type="text"
              class="form-control"
              name="chave-unica"
              id="chave-unica"
              v-model="updateData.unique_key"
              :placeholder="placeholder"
              :disabled="disable"
              @input="handleInput"
            >
          </div>
          <div class="custom-input-group">
            <label for="tipo">Tipo</label>
            <!-- <input type="text" class="form-control" name="tipo" id="tipo" v-model="updateData.number_contact" :disabled="disable"> -->
            <v-select :options="optionsDependentes" v-model="updateData.number_contact" name="tipo" id="tipo" :disabled="disable"></v-select>
          </div>
        </div>
      </div>
      <div>
        <div id="button-group">
          <button type="button" :hidden="disable"  @click="updateCl" class="btn btn-success cursor-pointer" id="btn-save"><i class="fa fa-save"></i>    Salvar</button>
          <button type="button" :hidden="disable"  @click="deleteCl" class="btn btn-danger cursor-pointer" id="btn-delete"><i class="fa fa-trash"></i>    Excluir</button>
          <button type="button" :hidden="!disable" @click="enableEdit" class="btn btn-info cursor-pointer" id="btn-edit"><i class="fa fa-edit"></i>    Editar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { parsePhoneNumberFromString, format } from 'libphonenumber-js';

export default {
  props:{
      data:{
        type: Object
      }
  },
  data(){
    return {
      show: true,
      arquivos: [],
      disable: true,
      subCompanyId: [4,5,6],
      optionsDependentes: ['Dependente', 'Funcionário'],
      optionsEmpresas: [],
      optionsSubEmpresas: [],
      updateData:{
        name: this.data.name,
        phone: this.data.phone,
        company_name: (this.data && this.data.company_name) ? this.data.company_name : '',
        corporation: (this.data && this.data.corporation) ? this.data.corporation : '',
        unique_key: this.data.unique_key,
        number_contact: this.data.number_contact
      },
      placeholder: 'XX.XXX.XXX-XX',
      options: {
        placeholder: 'Insira o telefone',
        required: true
      }
    }
  },
  async created(){
      // axios.get('/new-screen/show').then(data => this.arquivos = data.data);

      const res = await axios.get('/api/companies');
      const subRes = await axios.get('/api/subcompanies');

      this.optionsEmpresas = res.data;
      this.optionsSubEmpresas = subRes.data;
  },
  mounted(){
    this.$el.addEventListener('click', this.onClick);
    document.addEventListener('keyup', this.onClick);

  },
  destroyed() {
    this.$el.removeEventListener('click', this.onClick);
    document.removeEventListener('keyup', this.onClick);
  },
  computed: {
    getDefaultCountryCode() {
      try {
        const formattedPhoneNumber = '+' + this.updateData.phone; // Adiciona o símbolo "+" na frente do número de telefone
        const phoneNumber = parsePhoneNumberFromString(formattedPhoneNumber);
        
        if (!phoneNumber) {
          return null;
        }
        
        this.updateData.countryCode = '+' + phoneNumber.countryCallingCode; // Armazena o código do país em "countryCode" 

        const countryCodes = {
        '+1': 'US',   // Estados Unidos
        '+7': 'ru',   // Rússia
        '+20': 'eg',  // Egito
        '+27': 'za',  // África do Sul
        '+30': 'gr',  // Grécia
        '+31': 'nl',  // Países Baixos
        '+32': 'be',  // Bélgica
        '+33': 'fr',  // França
        '+34': 'es',  // Espanha
        '+36': 'hu',  // Hungria
        '+39': 'it',  // Itália
        '+40': 'ro',  // Romênia
        '+41': 'ch',  // Suíça
        '+43': 'at',  // Áustria
        '+44': 'gb',  // Reino Unido
        '+45': 'dk',  // Dinamarca
        '+46': 'se',  // Suécia
        '+47': 'no',  // Noruega
        '+48': 'pl',  // Polônia
        '+49': 'de',  // Alemanha
        '+51': 'pe',  // Peru
        '+52': 'mx',  // México
        '+53': 'cu',  // Cuba
        '+54': 'ar',  // Argentina
        '+55': 'br',  // Brasil
        '+56': 'cl',  // Chile
        '+57': 'co',  // Colômbia
        '+58': 've',  // Venezuela
        '+60': 'my',  // Malásia
        '+61': 'au',  // Austrália
        '+62': 'id',  // Indonésia
        '+63': 'ph',  // Filipinas
        '+64': 'nz',  // Nova Zelândia
        '+65': 'sg',  // Singapura
        '+66': 'th',  // Tailândia
        '+81': 'jp',  // Japão
        '+82': 'kr',  // Coreia do Sul
        '+84': 'vn',  // Vietnã
        '+86': 'cn',  // China
        '+90': 'tr',  // Turquia
        '+91': 'in',  // Índia
        '+92': 'pk',  // Paquistão
        '+93': 'af',  // Afeganistão
        '+94': 'lk',  // Sri Lanka
        '+95': 'mm',  // Mianmar (Birmânia)
        '+98': 'ir',  // Irã
        // Adicione outros códigos de país conforme necessário
      };
        this.updateData.countryCode = countryCodes[this.updateData.countryCode];
        return this.updateData.countryCode;
      } catch (error) {
        console.log('Erro ao formatar o número de telefone:', error);
        return null;
      }
    }
  },
  methods:{
    optionsSubEmpresasFilter(){
            
      if( this.updateData.company_name == null){
          this.company_name = {};
          this.company_name.label = null;
          this.updateData.corporation = null;
      }

      const filter = this.optionsSubEmpresas.filter(el => ((el.Empresa == this.updateData.company_name || el.Empresa == this.updateData.company_name?.label)));

      return filter;
    },
    handleInput() {
      const value = this.updateData.unique_key.replace(/\D/g, '').slice(0, 14);

      if (value.length === 11) {
        this.placeholder = 'CPF';
        this.$set(this.updateData, 'unique_key', value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'));
      } else if (value.length === 14) {
        this.placeholder = 'CNPJ';
        this.$set(this.updateData, 'unique_key', value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'));
      }
    },
    enableEdit(){
      this.disable = !this.disable;
    },
    onClick(e){
      if(e.target.id == 'outModal'|| e.key == 'Escape') this.$emit('dismissModal');
    },
    dismissModal(){
      this.$emit('dismissModal');
    },
    deleteCl(){
      axios.post('/customer_base/destroy', {id: this.data.id}).then(data => {
        Swal.fire(
          'Registro Excluído',
          'Este cliente não faz mais parte de sua base',
          'success'
        ).then((confirm) => {
          this.dismissModal();
        });
      });
    },
    updateCl(){
      this.updateData.phone = this.updateData.phone.replace(/\D/g,'');
      this.updateData.unique_key = this.updateData.unique_key.replace(/\D/g,'');

      this.updateData.company_name = (this.updateData.company_name && this.updateData.company_name.label) ? this.updateData.company_name.label : this.updateData.company_name;
      this.updateData.corporation = (this.updateData.corporation && this.updateData.corporation.label) ? this.updateData.corporation.label : this.updateData.corporation;

      axios.post('/customer_base/save', {
        id: this.data.id,
        name: this.updateData.name,
        phone: this.updateData.phone,
        company_name: this.updateData.company_name,
        corporation: this.updateData.corporation,
        unique_key: this.updateData.unique_key,
        number_contact: this.updateData.number_contact
      }).then(data => {
        Swal.fire(
          'Atualização realizada',
          'Os dados deste cliente foram atualizados',
          'success'
        ).then((confirm) => {
          this.dismissModal();
        });
      });
    },
  },

}
</script>

<style scoped>

.background-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color:rgba(125,125,125, 0.5);
}

.align-modal{
  display:flex;
  align-items: center;
  justify-content: center;
}

#header-row{
  display: flex;
  justify-content: space-between;
  background-color: #1c869a;
  border-top: 3px solid #f38630;
}

#header-title{
  color: white;
  font-weight: bold;
  margin: 5px 20px;
  align-self: center;
}

#close-button{
  font-weight: bolder;
  background-color: white;
  color: #aa1a1a;
  cursor: pointer;
  border: 1px solid #aa1a1a;
  border-radius: 10px !important;
  padding: 8px;
  align-self: center;
  margin: 5px;
}

#close-button:hover{
  background-color: #aa1a1a;
  color: white;
  transition: 0.5s;
  border: 1px solid white;
}

.content{
  background-color: #fff;
  width: 35em;
  border-radius: 15px;
  overflow: auto;
}

.body{
  display:flex;
  flex-flow: row wrap;
  overflow: auto;
  justify-content: center;
}
.row {
  width: 100%;
}

.body img{
    border-radius: 50%;
    height: 7em;
    border: 5px solid #1c869a66;
}

#img-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px;
}

#details-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px
}

.custom-input-group {
  padding: 10px;
}

.custom-input-group label {
  align-self: center;
  font-weight: bold;
}

#btn-save {
  color: white;
  background-color: #034103;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-save:hover {
  color: #034103;
  background-color: white;
  border: 3px solid #034103;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-delete {
  color: white;
  background-color: #aa1a1a;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-delete:hover {
  color: #aa1a1a;
  background-color: white;
  border: 3px solid #aa1a1a;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-edit {
  color: white;
  background-color: #0e0e69;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-edit:hover {
  color: #0e0e69;
  background-color: white;
  border: 3px solid #0e0e69;
  border-radius: 10px !important;
  transition: 0.5s;
}

#button-group {
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
}

</style>